module.exports = __webpack_public_path__ + "static/media/catching-catching-a-ball-person-svgrepo-com.e662f829.svg";